import { Button, ButtonGroup, useMediaQuery } from "@mui/material"
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import propTypes from 'prop-types'

import { ROTATION, UNLIMITED } from '../../constants'

// This is a v4 legacy use. I'm using it because non-mui components cannot access the sx property
// Check back here for updates to change later https://mui.com/system/basics/#4-any-element-with-the-babel-plugin
const useStyles = makeStyles({
    formatIconLeft: {
        width: '1.5em',
        marginRight: 10
    },
    formatIconRight: {
        width: '1.5em',
        marginLeft: 10
    }
})

const FormatButtons = ({ format, onFormatClick }) => {
    const theme = useTheme();
    const classes = useStyles()

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleFormatClick = (formatValue) => onFormatClick(formatValue)

    return (
        <ButtonGroup fullWidth={isSmallScreen} sx={{ mt: isSmallScreen ? 2 : 0 }}>
            <Button variant={format === ROTATION ? 'contained' : 'outlined'} onClick={() => handleFormatClick(ROTATION)}>
                <img src="/assets/icon_rotation.png" alt="rotation" className={classes.formatIconLeft} />
                Rotation
            </Button>
            <Button variant={format === UNLIMITED ? 'contained' : 'outlined'} onClick={() => handleFormatClick(UNLIMITED)}>
                Unlimited
                <img src="/assets/icon_unlimited.png" alt="unlimited" className={classes.formatIconRight} />
            </Button>
        </ButtonGroup>
    )
}

FormatButtons.propTypes = {
    format: propTypes.string.isRequired,
    onFormatClick: propTypes.func.isRequired
}

export default FormatButtons